import { FaLanguage } from "react-icons/fa";
import { useLanguage } from "../../hooks/useLanguage";

/**
 * Reusable Language Toggle Button Component
 * Works for both logged-in and non-logged-in users
 */
const LanguageToggleButton = ({
  className = "cart cart-profile",
  style = {},
  showText = true
}) => {
  const { selectedLang, changeLanguage } = useLanguage();

  const defaultStyle = {
    backgroundColor: '#1a1a1a',
    color: '#ffffff',
    border: '2px solid #333',
    fontWeight: '600',
    ...style
  };

  return (
    <button
      className={className}
      onClick={() => changeLanguage(selectedLang === "en" ? "fr" : "en")}
      style={defaultStyle}
      title={selectedLang === "en" ? "Switch to French" : "Passer à l'anglais"}
    >
      <FaLanguage size={20} color="#ffffff" />
      {showText && <p style={{ color: '#ffffff', fontWeight: '600' }}>{selectedLang === "en" ? "FR" : "EN"}</p>}
    </button>
  );
};

export default LanguageToggleButton;
